module.exports = __webpack_public_path__ + "media/images/turbochargers/05-113e9c3f57518f60491fc72f82459587.png";